import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./success.css";


function Success() {
  const navigate = useNavigate();
  const location = useLocation();
  const orderId = location.state?.orderId || "N/A";
  const orderDate = new Date().toLocaleString(); // Capture ordered date

  // Function to generate and download the order details file
  const downloadOrderFile = () => {
    const orderDetails = `Order ID: ${orderId}\nOrdered Date: ${orderDate}`;
    const blob = new Blob([orderDetails], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    
    // Create a temporary download link
    const link = document.createElement("a");
    link.href = url;
    link.download = `Order_${orderId}.txt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="success-container">
      <h2>🎉 Payment Successful! 🎉</h2>
      <p>Thank you for your payment. Your Order ID is:</p>
      <h3>{orderId}</h3>
      <p>Ordered Date: {orderDate}</p>
   

      {/* Download Button */}
      <button className="download-order-btn" onClick={downloadOrderFile}>
        📥 Download Order ID
      </button>

      {/* Navigate to Home Button */}
      <button className="paymet-success-button-to-navigate-home" onClick={() => navigate("/")}>
        Go to Home
      </button>
    </div>
  );
}

export default Success;
